import { useTheme } from '@mui/system';

export const FeedbackTextFieldSVGIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0791016 1.54486C0.0791016 0.716434 0.750673 0.0448608 1.5791 0.0448608H4.42437V1.04486H1.5791C1.30296 1.04486 1.0791 1.26872 1.0791 1.54486V4.04681H0.0791016V1.54486ZM0.0791016 18.4551C0.0791016 19.2836 0.750673 19.9551 1.5791 19.9551H4.42437V18.9551H1.5791C1.30296 18.9551 1.0791 18.7313 1.0791 18.4551V15.9532H0.0791016V18.4551ZM18.4208 0.0448608C19.2492 0.0448608 19.9208 0.716434 19.9208 1.54486V4.04681H18.9208V1.54486C18.9208 1.26872 18.6969 1.04486 18.4208 1.04486H15.5755V0.0448608H18.4208ZM19.9208 18.4551C19.9208 19.2836 19.2492 19.9551 18.4208 19.9551H15.5755V18.9551H18.4208C18.6969 18.9551 18.9208 18.7313 18.9208 18.4551V15.9532H19.9208V18.4551ZM4.04021 8.24929C4.04021 7.86248 4.35379 7.5489 4.7406 7.5489H16.4138C16.8006 7.5489 17.1141 7.86248 17.1141 8.24929C17.1141 8.63611 16.8006 8.94968 16.4138 8.94968H4.7406C4.35379 8.94968 4.04021 8.63611 4.04021 8.24929ZM4.04016 10.3506C4.04016 9.96376 4.35374 9.65018 4.74055 9.65018H8.72315C9.10997 9.65018 9.42354 9.96376 9.42354 10.3506C9.42354 10.7374 9.10997 11.051 8.72315 11.051H4.74055C4.35374 11.051 4.04016 10.7374 4.04016 10.3506Z"
        fill={theme.palette.text.primary}
      />
    </svg>
  );
};
